import React from "react"
import { BLOCKS, INLINES } from "@contentful/rich-text-types"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import Image from "gatsby-image"
import useContentfulImage from "./hooks/useContentfulImage"

const richTextOptions = {
  renderNode: {
    [INLINES.HYPERLINK]: node => {
      return (
        <a
          target="_blank"
          rel="noopener noreferrer nofollow"
          href={node.data.uri}
          // https://www.contentfulcommunity.com/t/add-a-target-blank-to-hyperlink-within-rich-text-content-type/2650/2
          // https://www.contentful.com/developers/docs/concepts/rich-text/
          // https://github.com/contentful/rich-text/issues/46
        >
          {node.content[0].value}
        </a>
      )
    },
    // [INLINES.HYPERLINK]: (node, next) => {
    //   return `<a class="markdown-link" href="${node.data.uri}">${next(node.content)}</a>`
    // },
    [BLOCKS.EMBEDDED_ASSET]: node => {
      const fluid = useContentfulImage(node.data.target.fields.file["uk"].url)
      const { title, description, file } = node.data.target.fields
      const mimeType = file["uk"].contentType
      const mimeGroup = mimeType.split("/")[0]

      switch (mimeGroup) {
        case "image":
          return (
            // <img
            //   title={title ? title.uk : null}
            //   alt={description ? description.uk : null}
            //   src={`https:${file["uk"].url}?fm=webp&q=100&w=320`}
            //   className="markdown-image"
            //   loading="lazy"
            // />
            <Image
              fluid={fluid}
              alt={description ? description.uk : null}
              title={title ? title.uk : null}
              className="markdown-image"
            />
          )
        default:
          return (
            <span style={{ backgroundColor: "red", color: "white" }}>
              embedded asset
              {/* {mimeType} embedded asset  */}
            </span>
          )
      }
    },
    [BLOCKS.EMBEDDED_ENTRY]: node => {
      const fields = node.data.target.fields
      switch (node.data.target.sys.contentType.sys.id) {
        case "blockquote":
          return (
            <div>
              <p>{fields}ЗАМЕНА</p>
            </div>
          )
        default:
          return <div>??????????????? </div>
      }
    },
  },
}

const ContentfulReachContent = ({ contentJSON }) =>
  documentToReactComponents(contentJSON, richTextOptions)

// let ContentfulReachContent = function(contentJSON){
//   return documentToReactComponents(JSON.parse(contentJSON.text), richTextOptions)
// }

export default ContentfulReachContent
